import ResumePDF from "../Resume.pdf";
export const Bio = {
  name: "Sunny Shinde",
  roles: ["Full Stack Developer", ".Net Developer", "Senior Software Engineer"],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/sunnyshinde8097/",
  resume: ResumePDF,
  linkedin: "https://www.linkedin.com/in/sunny-shinde-9a342514a/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
      },
      {
        name: "Redux",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
      },
      {
        name: "Angular 18",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg",
      },
      {
        name: "HTML",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
      },
      {
        name: "CSS",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
      },
      {
        name: "Flutter",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/flutter/flutter-original.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "C#",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg",
      },
      {
        name: ".NET",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg",
      },
      {
        name: "ML.NET",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg",
      }
      ,
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original.svg",
      }, {
        name: "Oracle SQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/oracle/oracle-original.svg",
      },
      {
        name: "NoSQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "Dapper",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg",
      },
      {
        name: "LINQ",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg",
      },
      {
        name: "Entity Framework",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg",
      }
      ,
      {
        name: "Java",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Firebase",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
      }, 
      {
        name: "Azure",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/azure/azure-original.svg"
      }
      
    ],
  },
  {
    title: "Version Control Tools",
    skills: [
      {
        name: "BitBucket",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bitbucket/bitbucket-original.svg",
      },
      {
        name: "Git",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
      },
      {
        name: "SVN",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/subversion/subversion-original.svg",
      },
      {
        name: "Linux",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg",
      },

    ]
  }
];

export const experiences = [
  {
    id: 0,
    role: "Software Engineer",
    img: require("../ExperienceImage/ICICLombard.png"),
    company: "ICICI Lombard Pvt. Ltd.",
    date: "May 2026 - Present",
    desc: "As a software developer, I specialize in ASP.NET core combined with C# for robust backend development and Microsoft SQL Server for effective database management. I oversee the complete lifecycle of web application development, including design, implementation, and continuous maintenance. Banking Application for Payment Processing System.",
    skills: [
      ".Net Core",
      "SQL server",
      "Angular 21",
      "LinQ",
      "Dapper",
      "JavaScript",
      "ML.NET"
    ],
  },
  {
    id: 1,
    role: "Software Engineer",
    img: require("../ExperienceImage/Webiknowns IT Solution pvt ltd.png"),
    company: "Webiknows Solution Pvt. Ltd.",
    date: "May 2024 - April 2026",
    desc: "As a software developer, I specialize in ASP.NET core combined with C# for robust backend development and Microsoft SQL Server for effective database management. I oversee the complete lifecycle of web application development, including design, implementation, and continuous maintenance. .",
    skills: [
      ".Net Core",
      "SQL server",
      "JQuery",
      "LinQ",
      "Dapper",
      "JavaScript",
    ],
  },
  {
    id: 2,
    role: "Jr.Software Engineer",
    img: require("../ExperienceImage/MasstechbussinessSolution pvt ltd.png"),
    company: "MassTech solution Pvt LTd",
    date: "Feb 2023 - April 2024",
    desc: "As a software developer, my expertise lies in leveraging ASP.NET paired with C# for backend development and Microsoft SQL Server for proficient database management. Within this role, I am accountable for the complete spectrum of web application development, encompassing design, implementation, and ongoing maintenance.. On the frontend, I am proficient in Angular, React.js, jQuery, and JavaScript, enabling me to deliver dynamic and user-friendly interfaces.   an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
    skills: [
      "ReactJS",
      "Redux",
      ".Net Core",
      "SQL server",
      "JQuery",
      "LinQ",
      "Dapper",
      "JavaScript",
      "Angular 17",
    ],
  },
];

export const projects = [
 
  {
    id: 1,
    title: "JK Cement uphaar",
    date: "Jun 2024 - Dec 2025",
    description:
      "JK Uphaar is a smart web app that simplifies task tracking and boosts workplace productivity. Admins can monitor employee activities in real time, while employees log tasks effortlessly through a clean, user-friendly interface.",
    image:
      require("../ProjectImage/JKCement/Home.png"),
    images: [
      require("../ProjectImage/JKCement/Home.png"),
      require("../ProjectImage/JKCement/Dashboard.png"),
      require("../ProjectImage/JKCement/Scheme Master.png"),
      require("../ProjectImage/JKCement/Transaction Report.png")
    ],
    tags: [
      ".NET Web API MVC",
      "JQuey",
      "Sql Server",
      "Entity Framework"
    ],
    category: "web app",
    webapp: "https://test.saluto.in/JKcement/login",
  },
  {
    id: 2,
    title: "PrincePipe",
    date: "Sept 2024 - Present",
    description:
      "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
    image:
      require("../ProjectImage/PrincePipe/PrincePipe-DashBoader.png"),
    images: [
      require("../ProjectImage/PrincePipe/Princepipe-Profile.png"),
      require("../ProjectImage/PrincePipe/Prince-Pipes-My-Ledges.png"),
      require("../ProjectImage/PrincePipe/PrincePipe-PinCodeMapping.png"),
      require("../ProjectImage/PrincePipe/PrincePipe-Redemption.png")
    ],
    tags: ["React Js", ".NET MVC", "SQL Server", "JQuery"],
    category: "web app",
    webapp: "https://test.saluto.in/PrincePipes/Login",
  },
  {
    id: 3,
    title: "JSW Star",
    date: "March 2024 - Present",
    description:
      "JSW Star is a premium, color-coated steel roofing and cladding solution from JSW Steel—India’s leading integrated steel producer known for sustainable, high-quality steel across flat and long product ranges. Built for Indian weather conditions, JSW Star combines high-strength base steel with advanced coatings to deliver long-lasting protection, vibrant aesthetics, and low maintenance for homes, industrial sheds, and commercial projects",
    image: require("../ProjectImage/JSW/JSWPaints.png"),
    images: [
      require("../ProjectImage/JSW/JSW-Profile.png"),
      require("../ProjectImage/JSW/JSW-Redemption.png"),
      require("../ProjectImage/JSW/JSW-Usermaster.png"),
      require("../ProjectImage/JSW/JSWPaints.png")
    ],
    tags: [
      "SQL Server",
      ".NET MVC",
      ".NET WEB API",
      "Entity FrameWork"
    ],
    category: "web app",
    webapp: "https://jswpaintsstar.woohoo.in/login",
  },
  {
    id: 4,
    title: "Devans Modern Breweries",
    date: "March 2024 - March 2025",
    description:
      "Devans Modern Breweries is a premium, color-coated steel roofing and cladding solution from D M B—India’s leading integrated steel producer known for sustainable, high-quality steel across flat and long product ranges. Built for Indian weather conditions, JSW Star combines high-strength base steel with advanced coatings to deliver long-lasting protection, vibrant aesthetics, and low maintenance for homes, industrial sheds, and commercial projects",
    image: require("../ProjectImage/DMB/DMB.png"),
    images: [
      require("../ProjectImage/DMB/Approve QR bar Code.png"),
      require("../ProjectImage/DMB/DMB.png"),
      require("../ProjectImage/DMB/QR master.png"),
      require("../ProjectImage/DMB/Approve QR bar Code.png")
    ],
    tags: [
      "SQL Server",
      "Angular",
      ".NET Core 8",
      ".NET WEB API",
      "Entity FrameWork"
    ],
    category: "web app",
    webapp: "https://test.saluto1.in/DMB/Login",
  },
  {
    id: 5,
    title: "Chess Game",
    date: "March 2024 - May 2024",
    description:
      "The Chess Game is a strategic two-player board game implemented in React.js. It recreates the classic experience of chess with an interactive digital interface, allowing players to move pieces via drag-and-drop and follow the official rules of the game",
    image:
      require("../ProjectImage/Chess Game/Chess game.png"),
    images: [
      require("../ProjectImage/Chess Game/Chess game.png"),
    ],
    tags: [
      "React JS"
    ],
    category: "web app",
    webapp: "https://candid-salmiakki-facbf2.netlify.app/",
  }, {
    id: 6,
    title: "Weather App",
    date: "March 2025 - May 2025",
    description:
      "The Weather App is a dynamic application built with React.js  and powered by the OpenWeather API. It provides real-time weather updates for any city worldwide, featuring an intuitive interface where users can search locations and instantly view temperature, humidity, wind speed, and conditions. Animated icons and background visuals enhance the experience, making weather data engaging and interactive.",
    image:
      require("../ProjectImage/Weather/Weatherapp.png"),
    images: [
      require("../ProjectImage/Weather/Weatherapp.png"),
    ],
    tags: [
      "React JS"
    ],
    category: "web app",
    webapp: "https://weather-git-master-avenger1.vercel.app/",
  }, {
    id: 7,
    title: "Ludo Game",
    date: "June 2024 - July 2024",
    description:
      "Ludo  is a race-style board game that blends luck and strategy. Each player controls four tokens, starting from their base, and must move them around the board and into the home column. The first player to successfully move all four tokens into the center home wins the game",
    image:
      require("../ProjectImage/Ludo/Ludo game.png"),
    images: [
      require("../ProjectImage/Ludo/Ludo game.png"),
    ],
    tags: [
      "React JS"
    ],
    category: "web app",
    webapp: "https://effervescent-bombolone-be6dcd.netlify.app/",
  }, {
    id: 8,
    title: "Loan Calculator",
    date: "Jan 2026 - Feb 2026",
    description:
      "A loan calculator helps you quickly estimate monthly payments, total interest, and repayment schedules based on loan amount, interest rate, and tenure. It simplifies financial planning by giving clear insights into borrowing costs",
    image:
      require("../ProjectImage/Loan Calculator/LoanCalculator.png"),
    images: [
      require("../ProjectImage/Loan Calculator/LoanCalculator.png"),
    ],
    tags: [
      "React JS"
    ],
    category: "web app",
    webapp: "https://loancal-seven.vercel.app/",
  },
  {
    id: 9,
    title: "Mankind Elite Club",
    date: "Dec 2024 - Present",
    description:
      "Mankind Elite Club (also known as Mankind Navratna Elite Club) is a loyalty and rewards program designed for retailers. Through its mobile app, members can track purchases, monitor loyalty points in real time, and redeem rewards seamlessly. The platform provides a transparent and user‑friendly interface, helping retailers stay updated on their progress toward incentives and manage their benefits conveniently",
    image:
      require("../ProjectImage/Mankind/mankind-login.jpeg"),
    images: [
      require("../ProjectImage/Mankind/Mankind-UPIQRScanner.jpeg"),
      require("../ProjectImage/Mankind/Mankind-PaymentGatway.jpeg"),
      require("../ProjectImage/Mankind/Mankind-Profile.jpeg"),
      require("../ProjectImage/Mankind/Mankind-Transaction.jpeg"),
      require("../ProjectImage/Mankind/Mankind-VisUpload.jpeg"),
      require("../ProjectImage/Mankind/Mankind-Redemption.jpeg"),
      require("../ProjectImage/Mankind/mankind-Menu.jpeg"),
      require("../ProjectImage/Mankind/Mankind-UPIQRScanner.jpeg"),
    ],
    tags: ["React js", "Flutter", ".NET Web API", ".Net MVC", "SQL Server", "LinQ", "Entity frameWork", "Dapper"],
    category: "android app",
    webapp: "https:/1/play.google.com/store/apps/details?id=com.mankind.mankind_navratna&hl=en-US",
  },
  {
    id: 11,
    title: "Greenply",
    date: "Jun 2024 - Present",
    description:
      "Greenply Green Samriddhi is a loyalty and rewards program designed for retailers, contractors, and carpenters associated with Greenply Industries. The initiative allows registered partners to earn points on every purchase of Greenply products through authorized dealers. These points can be tracked via a user‑friendly mobile app and redeemed for a wide range of gifts and vouchers. The program strengthens Greenply’s bond with its trade partners by offering transparent benefits, digital tracking, and additional incentives such as in‑shop meetings, recognition certificates, and exclusive rewards for top performers",
    image:
      require("../ProjectImage/Greenply/Greenply-Login.jpeg"),
    images: [
      require("../ProjectImage/Greenply/Greenply-Login.jpeg")
    ],
    tags: ["React js", "Flutter", ".NET Web API", ".Net MVC", "SQL Server", "LinQ", "Entity frameWork", "Dapper"],
    category: "android app",
    webapp: "https:/1/play.google.com/store/apps/details?id=com.greenply.greensamriddhiapp&hl=en-US",
  },
  {
    id: 12,
    title: "GreenplyBandhan",
    date: "Jun 2024 - Present",
    description:
      "Greenply Bandhan is a loyalty and rewards program designed for retailers, contractors, and carpenters associated with Greenply Industries. The initiative allows registered partners to earn points on every purchase of Greenply products through authorized dealers. These points can be tracked via a user‑friendly mobile app and redeemed for a wide range of gifts and vouchers. The program strengthens Greenply’s bond with its trade partners by offering transparent benefits, digital tracking, and additional incentives such as in‑shop meetings, recognition certificates, and exclusive rewards for top performers",
    image:
      require("../ProjectImage/GreenplyBandhan/LOginpage.png"),
    images: [
      require("../ProjectImage/GreenplyBandhan/LOginpage.png"),
      require("../ProjectImage/GreenplyBandhan/Redemption.png"),
      require("../ProjectImage/GreenplyBandhan/USermater.png"),
    ],
    tags: ["React js", "Flutter", ".NET Web API", ".Net MVC", "SQL Server", "LinQ", "Entity frameWork", "Dapper"],
    category: "android app",
    webapp: "https:/1/play.google.com/store/apps/details?id=com.greenply.greenply_bandhan&hl=en-US",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
];

export const certifications = [
  {
    id: 1,
    title: "C# Advance Certification",
    issuer: "Udemy",
    date: "Apr 2024",
    description: "Successfully completed certification in C#, demonstrating the ability to design and implement autonomous agents for real‑world applications. Gained hands‑on expertise in multi‑agent workflows, decision‑making, and tool integration using modern frameworks. Strengthened coding skills by building projects that showcase LLM orchestration, API interaction, and scalable agent design",
    image: require("../ProjectImage/Certifications/C# Certification.png"),
    link: "https://www.udemy.com/certificate/UC-d474a2b1-8b0f-4208-bfb0-bf721dc55d01/",
  },
  {
    id: 2,
    title: "IBM JAVA Fundamentals",
    issuer: "IBM",
    date: "Jan 2023",
    description: "Mastered core Java programming concepts, including object-oriented programming principles, data types, logic structures, and standard libraries. Validated foundational knowledge required for enterprise-ready software development.",
    image: require("../ProjectImage/Certifications/IBM Java Fundamental.png"),
    link: "https://courses.itvedant.skillsnetwork.site/certificates/958e13878c5d48f281af952c89c66772",
  },
  {
    id: 3,
    title: "Angular 18",
    issuer: "IT Vedant",
    date: "Jan 2024",
    description: "Gained proficient knowledge of the Angular 18 framework, covering component-driven architecture, reactivity, advanced routing, RxJS, and building robust, scalable single-page web applications.",
    image: require("../ProjectImage/Certifications/Angular.png"),
    link: "https://drive.google.com/file/d/1207-9LpQtKRoELMhmVW1owKooGckW60y/view",
  },
  {
    id: 4,
    title: "React",
    issuer: "IT Vedant",
    date: "Sep 2023",
    description: "Successfully solved complex UI problems and demonstrated proficiency in React, including functional components, hooks, component lifecycle, and complex state management.",
    image: require("../ProjectImage/Certifications/React.png"),
    link: "https://drive.google.com/drive/folders/1OLrCMmvIB07ytGpZhRnc2oakIQVFPhCS",
  },
  {
    id: 5,
    title: "SQL Server",
    issuer: "IT Vedant",
    date: "Sep 2023",
    description: "Successfully solved complex UI problems and demonstrated proficiency in React, including functional components, hooks, component lifecycle, and complex state management.",
    image: require("../ProjectImage/Certifications/SQL.png"),
    link: "https://drive.google.com/drive/folders/1qO0G7N0iwoJsdL40GGS7NqgRPtxmK43b",
  },{
    id: 6,
    title: "AI Agent Certification",
    issuer: "SimpleLearn",
    date: "Apr 2025",
    description: "Successfully completed certification in Agentic AI, demonstrating the ability to design and implement autonomous agents for real‑world applications. Gained hands‑on expertise in multi‑agent workflows, decision‑making, and tool integration using modern frameworks. Strengthened coding skills by building projects that showcase LLM orchestration, API interaction, and scalable agent design",
    image: require("../ProjectImage/Certifications/AI Agent Certification.png"),
   // link: "https://drive.google.com/drive/folders/1qO0G7N0iwoJsdL40GGS7NqgRPtxmK43b",
  }
];

